<div style="margin: 16px 0;">
    <label style="display: block; margin-bottom: 8px;">Conversation Name:</label>
    <input nz-input [(ngModel)]="conversationName" placeholder="Enter a name for this conversation..."
        (keydown.enter)="handleOk()" autofocus />
</div>

<div *nzModalFooter>
    <button nz-button (click)="handleCancel()">Cancel</button>
    <button nz-button nzType="primary" (click)="handleOk()" [disabled]="!conversationName.trim()">
        Save
    </button>
</div>